module.exports = __webpack_public_path__ + "img/rosa-pink.png";